import { Navigate, Outlet, useRoutes } from "react-router-dom";

import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
import { PATH_AFTER_LOGIN } from "../config-global";
import VehicleTypes from "../pages/settings/vehicles/VehicleTypes";
import { Layout } from "../routers";
import {
  Admins,
  Badges,
  CancelReasons,
  Categories,
  Commissions,
  Customers,
  DeletedUsers,
  DocumentTypes,
  EmergencyContacts,
  Faqs,
  FaqsCategories,
  Fares,
  FareTypes,
  LandingPage,
  LoginPage,
  MyProfile,
  Notifications,
  Otp,
  PromoCodes,
  Ratings,
  Reports,
  ReportTypes,
  Rewards,
  Riders,
  Roles,
  ServiceAreas,
  Settings,
  SuspendPolicies,
  TodayRides,
  Transactions,
  VehicleBrands,
  VehicleCC,
  VehicleColors,
  VehicleModels,
  Wallets,
} from "./elements";

//

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    {
      path: "/admin",
      element: (
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "dashboard",
          element: (
            <Layout>
              <LandingPage />
            </Layout>
          ),
        },

        {
          path: "my-profile",
          element: (
            <Layout>
              <MyProfile />
            </Layout>
          ),
        },

        {
          path: "notifications",
          element: (
            <Layout>
              <Notifications />
            </Layout>
          ),
        },

        {
          path: "trips",
          element: (
            <Layout>
              <TodayRides />
            </Layout>
          ),
        },

        {
          path: "accounts/transactions",
          element: (
            <Layout>
              <Transactions />
            </Layout>
          ),
        },

        {
          path: "accounts/wallets",
          element: (
            <Layout>
              <Wallets />
            </Layout>
          ),
        },

        {
          path: "trip-history",
          element: (
            <Layout>
              <TodayRides />
            </Layout>
          ),
        },

        // TODO: users
        {
          path: "/admin/users",
          children: [
            {
              element: <Navigate to="/admin/users/admins" replace />,
              index: true,
            },
            {
              path: "admins",
              element: (
                <Layout>
                  <Admins />
                </Layout>
              ),
            },

            {
              path: "customers",
              element: (
                <Layout>
                  <Customers />
                </Layout>
              ),
            },

            {
              path: "riders",
              element: (
                <Layout>
                  <Riders />
                </Layout>
              ),
            },

            {
              path: "riders",
              element: (
                <Layout>
                  <Riders title={"Riders"} />
                </Layout>
              ),
            },

            {
              path: "today-riders",
              element: (
                <Layout>
                  <Riders title={"Today Riders"} />
                </Layout>
              ),
            },

            {
              path: "deleted-users",
              element: (
                <Layout>
                  <DeletedUsers />
                </Layout>
              ),
            },

            {
              path: "users-otp",
              element: (
                <Layout>
                  <Otp />
                </Layout>
              ),
            },

            {
              path: "roles",
              element: (
                <Layout>
                  <Roles />
                </Layout>
              ),
            },

            {
              path: "permissions",
              element: (
                <Layout>
                  <Roles />
                </Layout>
              ),
            },

            // { path: "add", element: <CreateSeason /> },
            // {
            //   path: "view/:slug",
            //   element: <Seasons isEdit={false} view={true} />,
            // },
            // { path: "detail/:slug", element: <Seasons isEdit={true} /> },
          ],
        },

        // TODO: vehicles
        {
          path: "/admin/settings",
          children: [
            {
              path: "",
              element: (
                <Layout>
                  <Settings />
                </Layout>
              ),
              index: true,
            },
            {
              element: <Navigate to="/admin/settings/vehicles" replace />,
            },
            {
              path: "vehicles",
              element: (
                <Layout>
                  <Admins />
                </Layout>
              ),
            },

            {
              path: "vehicles/types",
              element: (
                <Layout>
                  <VehicleTypes />
                </Layout>
              ),
            },

            {
              path: "vehicles/brands",
              element: (
                <Layout>
                  <VehicleBrands />
                </Layout>
              ),
            },

            {
              path: "vehicles/cc",
              element: (
                <Layout>
                  <VehicleCC />
                </Layout>
              ),
            },

            {
              path: "vehicles/colors",
              element: (
                <Layout>
                  <VehicleColors />
                </Layout>
              ),
            },

            {
              path: "vehicles/models",
              element: (
                <Layout>
                  <VehicleModels />
                </Layout>
              ),
            },

            {
              path: "promo-code",
              element: (
                <Layout>
                  <PromoCodes />
                </Layout>
              ),
            },

            {
              path: "badges",
              element: (
                <Layout>
                  <Badges />
                </Layout>
              ),
            },

            {
              path: "commissions",
              element: (
                <Layout>
                  <Commissions />
                </Layout>
              ),
            },
            {
              path: "rewards",
              element: (
                <Layout>
                  <Rewards />
                </Layout>
              ),
            },

            {
              path: "document-types",
              element: (
                <Layout>
                  <DocumentTypes />
                </Layout>
              ),
            },

            {
              path: "report-types",
              element: (
                <Layout>
                  <ReportTypes />
                </Layout>
              ),
            },

            {
              path: "categories",
              element: (
                <Layout>
                  <Categories />
                </Layout>
              ),
            },

            {
              path: "suspend-policies",
              element: (
                <Layout>
                  <SuspendPolicies />
                </Layout>
              ),
            },

            {
              path: "service-areas",
              element: (
                <Layout>
                  <ServiceAreas />
                </Layout>
              ),
            },

            {
              path: "fares/list",
              element: (
                <Layout>
                  <Fares />
                </Layout>
              ),
            },

            {
              path: "fares/types",
              element: (
                <Layout>
                  <FareTypes />
                </Layout>
              ),
            },
          ],
        },
        {
          path: "review-ratings",
          element: (
            <Layout>
              <Ratings />
            </Layout>
          ),
        },

        // TODO: supports
        {
          path: "/admin/supports",
          children: [
            {
              element: <Navigate to="/admin/supports/faqs" replace />,
              index: true,
            },

            {
              path: "faqs",
              element: (
                <Layout>
                  <Faqs />
                </Layout>
              ),
            },

            {
              path: "faqs-categories",
              element: (
                <Layout>
                  <FaqsCategories />
                </Layout>
              ),
            },

            {
              path: "cancel-reasons",
              element: (
                <Layout>
                  <CancelReasons />
                </Layout>
              ),
            },

            {
              path: "emergency-contacts",
              element: (
                <Layout>
                  <EmergencyContacts />
                </Layout>
              ),
            },

            {
              path: "reports/list",
              element: (
                <Layout>
                  <Reports />
                </Layout>
              ),
            },

            {
              path: "reports/types",
              element: (
                <Layout>
                  <ReportTypes />
                </Layout>
              ),
            },
          ],
        },
      ],
    },
    // {
    //   element: <CompactLayout />,
    //   children: [{ path: "404", element: <Page404 /> }],
    // },

    // { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
